import React from "react";
import { useTranslation } from "react-i18next";

import { NewProjectModalProps } from "./NewProjectModal.types.tsx";
import { NewProjectButton } from "../../components/Buttons.tsx";

const NewProjectModal: React.FC<NewProjectModalProps> = ({
  show,
  handleClose,
  onStandardProject,
  onCustomProject,
}) => {
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <div
      onMouseLeave={handleClose}
      style={{
        position: "absolute",
        top: "0px",
        left: "64px",
        display: "flex",
        gap: "8px",
        flexDirection: "column",
        padding: "10px",
        borderRadius: "8px",
        zIndex: 9999,
      }}
    >
      <NewProjectButton onClick={onStandardProject}>
        {t("newProjectModal.standard")}
      </NewProjectButton>

      <NewProjectButton onClick={onCustomProject}>{t("newProjectModal.custom")}</NewProjectButton>
    </div>
  );
};

export default NewProjectModal;
